if ($(".js-main-news").length) {
    $(".js-main-news").each(function() {
        const mainNewsSlider = new Swiper(this, {
            slidesPerView: "auto",
            spaceBetween: 1,
            navigation: {
                nextEl: $(this).closest('.main-news').find('.js-main-news-next')[0],
                prevEl: $(this).closest('.main-news').find('.js-main-news-prev')[0],
            },
            breakpoints: {
                768: {
                    spaceBetween: 49,
                    slidesPerView: "auto",
                },
                1140: {
                    slidesPerView: 3,
                    spaceBetween: 49,
                },
            },
        });
    });
}